/* assets/cuff-add-on.js (Liberator STORE) — moved out of snippets/cuff-add-on.liquid on 2026-10-13 (was inline).
   Loaded with defer by the snippet; a tiny inline script there places the scroller above Add to cart right away.
   Note: the "added to cart" toast now fills in the product title correctly (inline, Liquid blanked out its placeholder). */
(function () {
  if (window.customElements.get('cuff-add-on')) return;

  class CuffAddOn extends HTMLElement {
    connectedCallback() {
      this._abort = new AbortController();
      var signal = this._abort.signal;

      this.formId = this.getAttribute('data-form-id');
      this.parentTitle = this.getAttribute('data-parent-title') || '';
      this.form = document.getElementById(this.formId);
      this.toggleBtn = this.querySelector('.cuff-add-on__toggle');
      if (!this.form) return;

      // Sit directly above the Add to cart button.
      var buyButtons = this.form.querySelector('buy-buttons');
      if (buyButtons && buyButtons.parentNode && buyButtons.previousElementSibling !== this) {
        buyButtons.parentNode.insertBefore(this, buyButtons);
      }

      // Expand / collapse the scroller. Nothing is pre-selected.
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', function () {
          var willOpen = !this.classList.contains('is-open');
          this.classList.toggle('is-open', willOpen);
          this.toggleBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        }.bind(this), { signal: signal });
      }

      // Selected-card styling; reset quantity to 1 when a card is unticked.
      this.addEventListener('change', function (e) {
        if (e.target && e.target.classList.contains('cuff-add-on__checkbox')) {
          var card = e.target.closest('.cuff-add-on__card');
          if (!card) return;
          card.classList.toggle('is-selected', e.target.checked);
          if (!e.target.checked) {
            var v = card.querySelector('.cuff-add-on__qty-val');
            if (v) v.textContent = '1';
          }
        }
      }, { signal: signal });

      // Quantity stepper. Guarded so tapping it never toggles the card.
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('.cuff-add-on__qty-btn');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('.cuff-add-on__card');
          var valEl = card.querySelector('.cuff-add-on__qty-val');
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var next = Math.max(1, (parseInt(valEl.textContent, 10) || 1) + step);
          valEl.textContent = String(next);
          return;
        }
        if (e.target.closest('.cuff-add-on__qty')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, { signal: signal });

      // Capture phase on document, so we run BEFORE the theme's product-form
      // submit handler (which is bound on the form itself, target phase).
      document.addEventListener('submit', this._onSubmit.bind(this), { capture: true, signal: signal });
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
    }

    async _onSubmit(event) {
      var self = this;
      var form = event.target;
      if (form !== this.form) return;

      var checkedBoxes = Array.from(this.querySelectorAll('.cuff-add-on__checkbox')).filter(function (cb) { return cb.checked; });
      if (checkedBoxes.length === 0) return; // nothing ticked, let the theme add normally

      event.preventDefault();
      event.stopImmediatePropagation();

      if (event.submitter && event.submitter.getAttribute('aria-busy') === 'true') return;
      if (!form.checkValidity()) { form.reportValidity(); return; }

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var settings = (window.themeVariables && window.themeVariables.settings) || {};

      // Furniture line from the existing form (preserves variant id, quantity,
      // and any line item properties from other blocks).
      var fd = new FormData(form);
      var furniture = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: {} };
      for (var pair of fd.entries()) {
        var match = pair[0].match(/^properties\[(.+)\]$/);
        if (match) furniture.properties[match[1]] = pair[1];
      }
      if (Object.keys(furniture.properties).length === 0) delete furniture.properties;

      // Each cuff at its own chosen quantity, independent of the furniture.
      var items = [furniture];
      checkedBoxes.forEach(function (cb) {
        var card = cb.closest('.cuff-add-on__card');
        var valEl = card ? card.querySelector('.cuff-add-on__qty-val') : null;
        var qty = valEl ? Math.max(1, parseInt(valEl.textContent, 10) || 1) : 1;
        items.push({
          id: Number(cb.getAttribute('data-variant-id')),
          quantity: qty,
          properties: { '_cuff_addon': 'added', 'Add-on for': self.parentTitle }
        });
      });

      // Ask the cart drawer (and any other listener) which sections to
      // re-render, exactly like the theme's own product-form does.
      var sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      var submitButtons = Array.from(form.elements).filter(function (el) { return el.type === 'submit'; });
      submitButtons.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: Array.from(sectionsToBundle).join(',') })
        });
        var responseJson = await response.json();

        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        if (!response.ok) {
          form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson.message } }));
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: responseJson.message, tone: 'error' } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return;
        }

        if (settings.cartType === 'page' || settings.pageType === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        var cartContent = await (await fetch(root + 'cart.js')).json();
        cartContent.sections = responseJson.sections;
        var addedItems = responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson];

        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cartContent } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cartContent }
        }));

        if (settings.cartType === 'message' && window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addedToCart) {
          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: { message: window.themeVariables.strings.addedToCart.replace('{{product_title}}', (addedItems[0] && addedItems[0].title) || '') }
          }));
        }
      } catch (e) {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        // Never block the sale. Untick add-ons and fall back to the native flow.
        Array.from(self.querySelectorAll('.cuff-add-on__checkbox')).forEach(function (cb) { cb.checked = false; });
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      }
    }
  }

  window.customElements.define('cuff-add-on', CuffAddOn);
})();
